App.CategoryController = Em.Controller.extend
  # Связывание с родительским котроллером
  needs : [ 'categories' ]
  categoriesBinding: 'controllers.categories.model'
  restaurantsBinding: 'controllers.categories.restaurants'
  categoryBinding: 'model'
  showPopover: false

  canEditMenu: Em.computed.alias('controllers.categories.canEditMenu')
  cantEditMenu: Em.computed.alias('controllers.categories.cantEditMenu')

  smSortableDisabled: Em.computed.alias('controllers.categories.smSortableDisabled')

  categoryNameBinding: Em.Binding.oneWay('category.name')

  fileInput: null

  headerStyle: (->
    photo = @get('category.photo.large')

    style =
    if photo
      "background-image: url(#{photo});"
    else
      ''

    style.htmlSafe()
  ).property('category.photo.large')

  ###
  # Блюда, отсортированные по menu_order
  ###
  dishesSortOrder: [ 'menu_order' ]
  sortedDishes: Em.computed.sort('dishes', 'dishesSortOrder')

  ###
  # Автоматическое сохранение названия категории
  ###
  saveCategoryName: ->
    name      = @get 'categoryName'
    modelName = @get 'category.name'

    return if !name or name is modelName
    @get('category').set('name', name).save()

  onCategoryNameChanged: (->
    Em.run.debounce @, @saveCategoryName, 600
  ).observes('categoryName')

  actions:
    reorderDish: (dish, target, layout, rerender) ->
      # блокируем, чтобы убрать мерцание
      @get('dishes').forEach (d) -> d.beginPropertyChanges()

      # пересчитываем индексы на клиенте
      layout.forEach (pair) -> pair[1].set('menu_order', pair[0])

      dish.reorder(target.get('id')).then =>
        rerender()
        Em.run.scheduleOnce 'afterRender', =>
          @get('dishes').forEach (d) -> d.endPropertyChanges()
      false

    toggleDishVisibility: (dish) ->
      dish.toggleProperty('is_hidden')
      dish.save()
      false

    openDishModal: (dish) ->
      @transitionToRoute('category.dish', dish)
      false

    toggleSettingsPopover: ->
      @toggleProperty('showPopover')
      false

    openFileDialog: ->
      @get('fileInput').send('openDialog')
      false

    uploadCategoryPhoto: (file) ->
      category = @get('category')
      category.uploadPhoto(file).then =>
        category.reload()
      false

    deleteCategory:  ->
      # todo i18n
      if confirm 'Удалить категорию? Все блюда из категории будут удалены.'
        model = @get('model')
        model.destroyRecord()
        .then =>
          @get('categories').removeObject(model)
          @transitionToRoute 'categories'

      false

